var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('statement-detail',{attrs:{"id":_vm.id,"versionId":_vm.id,"isApproval":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }